<template>
  <el-select
    v-model="internalValue"
    multiple
    filterable
    remote
    reserve-keyword
    clearable
    :remote-method="remoteMethod"
    :style="{ width: inputWidth, '--inputWidth': inputWidth }"
    :loading="loading"
    value-key="id"
    class="fetch-select"
    popper-class="fetch-select-class"
    data-width="100px"
    :placeholder="placeholder"
  >
    <el-option v-for="i in internalValue" hidden :key="i.id" :label="i.name" :value="i" />
    <template v-if="!options.length && filterWord">
      <div class="fetch-select-none">无搜索结果</div>
    </template>
    <template v-else-if="filterWord">
      <el-option :style="{ width: inputWidth }" v-for="i in options" :key="'option_' + i.id" :label="i.name" :value="i">
        <el-tooltip v-if="i.name.length > 13" :content="i.name" effect="dark" placement="right">
          <span v-html="i.showName"></span>
        </el-tooltip>
        <span v-else v-html="i.showName"></span>
      </el-option>
    </template>
    <template v-else>
      <el-option
        :style="{ width: inputWidth }"
        v-for="i in internalValue"
        :key="'default_' + i.id"
        :label="i.name"
        :value="i"
      >
        <el-tooltip v-if="i.name.length > 13" :content="i.name" effect="dark" placement="right">
          <span v-html="i.showName"></span>
        </el-tooltip>
        <span v-else v-html="i.showName"></span>
      </el-option>
    </template>
  </el-select>
</template>

<script>
import { services } from '@/service';

export default {
  data() {
    return {
      options: [],
      loading: false,
      filterWord: ''
    };
  },
  props: {
    value: {
      required: true
    },
    inputWidth: {
      type: String,
      default: '200px'
    },
    // 案件类型/审理程序/审理法院/案由
    type: {
      type: String,
      default: '案由'
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      }
    }
  },
  methods: {
    async remoteMethod(query) {
      try {
        this.filterWord = query;
        if (query !== '') {
          this.loading = true;
          const params = {
            size: 5000,
            highlight: {
              pre_tags: ["<span style='color:red'>"],
              post_tags: ['</span>'],
              fields: {
                name: {
                  boundary_scanner_locale: 'zh_CN',
                  boundary_scanner: 'sentence',
                  type: 'unified',
                  fragmenter: 'span',
                  fragment_size: 5000
                }
              },
              number_of_fragments: 1000
            },
            query: {
              bool: {
                must: [{ term: { 'typename.keyword': this.type } }],
                should: [
                  {
                    dis_max: {
                      queries: [
                        {
                          constant_score: {
                            filter: {
                              match_phrase: {
                                name: query
                              }
                            },
                            boost: 6
                          }
                        },
                        {
                          constant_score: {
                            filter: {
                              query_string: {
                                query: this.formatString(query),
                                fields: ['name']
                              }
                            },
                            boost: 4
                          }
                        }
                      ]
                    }
                  }
                ],
                minimum_should_match: 1
              }
            },
            sort: [
              {
                _score: 'desc'
              },
              {
                _script: {
                  script: {
                    source: "doc['name.keyword'].size()>0 ?doc['name.keyword'].value.length():0",
                    lang: 'painless'
                  },
                  type: 'number',
                  order: 'asc'
                }
              }
            ]
          };

          params.query.bool.must_not = [
            {
              term: {
                hide: true
              }
            },
            {
              term: {
                disable: true
              }
            }
          ];

          const { hits } = await services.courseware.getCourseCrime(params);
          this.options = hits.hits.map(i => {
            return {
              id: i._source.id,
              name: i._source.name,
              showName: i.highlight.name[0]
            };
          });
        } else {
          this.options = [];
        }
      } catch (err) {
        this.$error(err);
      } finally {
        this.loading = false;
      }
    },
    formatString(input) {
      const formattedString = input.replace(/./g, '"$&"AND').slice(0, -3);
      return `(${formattedString})`;
    }
  }
};
</script>
<style lang="less">
.fetch-select-none {
  padding: 10px 0;
  text-align: center;
  color: #999;
  font-size: 14px;
}
.fetch-select {
  .el-select__tags-text {
    display: inline-block;
    max-width: calc(var(--inputWidth) - 70px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.fetch-select-class {
  .el-select-dropdown__item {
    > span {
      display: inline-block;
      max-width: 95%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fetchSelect.vue